// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.referral-release-plans-page .dashboard-body {
  padding-bottom: 2rem;
}

.referral-plans-hero__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
}

.referral-plans-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}

.referral-plans-btn-primary,
.referral-plans-btn-secondary,
.referral-plans-btn-danger {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 0.55rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid transparent;
}

.referral-plans-btn-primary {
  background: #0f766e;
  color: #fff;
  border-color: #0d6560;
}

.referral-plans-btn-primary:hover:not(:disabled) {
  background: #0d9488;
}

.referral-plans-btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.referral-plans-btn-view {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-family: inherit;
  font-size: 0.86rem;
  font-weight: 600;
  padding: 0.45rem 0.9rem;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #0f766e;
  background: #fff;
  color: #0f766e;
  white-space: nowrap;
}

.referral-plans-btn-view:hover:not(:disabled) {
  background: #f0fdfa;
}

.referral-plans-btn-view:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.referral-plans-btn-secondary {
  background: #fff;
  color: #334155;
  border-color: #e2e8f0;
}

.referral-plans-btn-secondary:hover:not(:disabled) {
  background: #f8fafc;
}

.referral-plans-btn-danger {
  background: #b91c1c;
  color: #fff;
  border-color: #991b1b;
}

.referral-plans-btn-danger:hover:not(:disabled) {
  background: #dc2626;
}

.referral-plans-card {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.referral-plans-card__title {
  margin: 0 0 1rem;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text, #1e293b);
}

.referral-plans-loading {
  color: #64748b;
  padding: 0.5rem 0;
}

.referral-plans-empty {
  color: #64748b;
  margin: 0;
}

.referral-plans-msg {
  margin: 0.75rem 0 0;
  font-size: 0.9rem;
}

.referral-plans-msg--error {
  color: #b91c1c;
}

.referral-plans-msg--success {
  color: #0f766e;
}

.referral-plans-table-wrap {
  overflow-x: auto;
}

.referral-plans-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.86rem;
}

.referral-plans-table th,
.referral-plans-table td {
  text-align: left;
  padding: 0.65rem 0.75rem;
  border-bottom: 1px solid #e2e8f0;
  vertical-align: top;
}

.referral-plans-table th {
  font-weight: 600;
  color: #475569;
  background: #f8fafc;
}

.referral-plans-table__name {
  font-weight: 600;
  color: #0f172a;
}

.referral-plans-table__created {
  color: #334155;
  font-size: 0.88rem;
  white-space: nowrap;
}

.referral-plans-table__actions-col {
  text-align: right;
  width: 1%;
  white-space: nowrap;
  vertical-align: middle;
}


.referral-plans-badge {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
}

.referral-plans-badge--on {
  background: #d1fae5;
  color: #047857;
}

.referral-plans-badge--off {
  background: #f1f5f9;
  color: #64748b;
}

.referral-plans-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 0.5rem;
  align-items: center;
}

.referral-plans-linkbtn {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  color: #0f766e;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.referral-plans-linkbtn:hover:not(:disabled) {
  color: #0d9488;
}

.referral-plans-linkbtn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  text-decoration: none;
}

.referral-plans-linkbtn--danger {
  color: #b91c1c;
}

.referral-plans-linkbtn--danger:hover:not(:disabled) {
  color: #dc2626;
}

.referral-plans-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.referral-plans-modal-overlay--confirm {
  z-index: 1200;
  background: rgba(15, 23, 42, 0.6);
}

.referral-plans-confirm {
  text-align: center;
}

.referral-plans-confirm__icon {
  width: 48px;
  height: 48px;
  margin: 0 auto 0.85rem;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff7ed;
  color: #c2410c;
  font-size: 1.2rem;
}

.referral-plans-confirm__warn {
  margin: 0 0 1.15rem;
  font-size: 0.82rem;
  line-height: 1.5;
  color: #9a3412;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 10px;
  padding: 0.7rem 0.8rem;
  text-align: left;
}

.referral-plans-confirm .referral-plans-modal__footer {
  justify-content: center;
}

.referral-plans-modal-overlay--view {
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
}

.referral-plans-modal {
  background: #fff;
  border-radius: 12px;
  max-width: 640px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
}

.referral-plans-modal--sm {
  max-width: 400px;
  padding: 1.5rem;
}

.referral-plans-modal--view {
  max-width: 640px;
  border-radius: 18px;
  box-shadow: 0 24px 50px rgba(15, 23, 42, 0.22);
  border: 1px solid #e2e8f0;
}

.referral-plans-modal__head--view {
  padding: 1.2rem 1.4rem 1.15rem;
  border-bottom: none;
  background: linear-gradient(135deg, #0f766e 0%, #0d9488 55%, #14b8a6 100%);
  color: #fff;
  align-items: flex-start;
  gap: 1rem;
}

.rrp-view-head {
  min-width: 0;
  flex: 1 1;
}

.rrp-view-head__row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.55rem 0.75rem;
  margin-top: 0.25rem;
}

.referral-plans-modal__head--view h2 {
  color: #fff;
  font-size: 1.28rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin: 0;
  line-height: 1.25;
}

.referral-plans-view-head-eyebrow {
  margin: 0;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.8);
}

.rrp-view-pill--on-dark.referral-plans-pill--active {
  background: rgba(187, 247, 208, 0.22);
  color: #ecfdf5;
  border-color: rgba(167, 243, 208, 0.45);
}

.rrp-view-pill--on-dark.referral-plans-pill--inactive {
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.9);
  border-color: rgba(255, 255, 255, 0.22);
}

.referral-plans-modal__close--on-dark {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
}

.referral-plans-modal__close--on-dark:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.22);
}

.referral-plans-view-body {
  padding: 0 1.25rem 0.5rem;
  max-height: min(70vh, 600px);
  overflow-y: auto;
}

.referral-plans-view-body--premium {
  padding: 1.25rem 1.35rem 1rem;
  max-height: min(72vh, 680px);
  background: #f8fafc;
}

.referral-plans-view-loading {
  text-align: center;
  padding: 2.5rem 1rem;
  color: #64748b;
}

.rrp-view-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.7rem;
  margin-bottom: 0.9rem;
}

@media (max-width: 560px) {
  .rrp-view-meta {
    grid-template-columns: 1fr;
  }
}

.rrp-view-meta__item {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.8rem 0.85rem;
}

.rrp-view-meta__item > i {
  color: #0f766e;
  font-size: 0.9rem;
  margin-top: 0.15rem;
}

.rrp-view-meta__label {
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
}

.rrp-view-meta__value {
  display: block;
  margin-top: 0.15rem;
  font-size: 0.86rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.35;
}

.referral-plans-pill {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  letter-spacing: 0.02em;
}

.referral-plans-pill--active {
  background: #d1fae5;
  color: #047857;
  border: 1px solid #a7f3d0;
}

.referral-plans-pill--inactive {
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

.referral-plans-view-rounds-block {
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.referral-plans-view-rounds-block__head {
  padding: 0.95rem 1.15rem 0.8rem;
  border-bottom: 1px solid #f1f5f9;
}

.referral-plans-view-rounds-block__head h3 {
  margin: 0 0 0.2rem;
  font-size: 0.98rem;
  font-weight: 700;
  color: #0f172a;
}

.referral-plans-view-rounds-block__head p {
  margin: 0;
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.4;
}

.referral-plans-empty--in-card {
  padding: 1.5rem 1.25rem;
  margin: 0;
  text-align: center;
}

.rrp-round-list {
  list-style: none;
  margin: 0;
  padding: 0.65rem 0.85rem 0.85rem;
}

.rrp-round {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  gap: 0.85rem;
  position: relative;
  padding: 0.7rem 0 0.85rem;
}

.rrp-round:not(:last-child)::before {
  content: "";
  position: absolute;
  left: 17px;
  top: 42px;
  bottom: 0;
  width: 2px;
  background: #e2e8f0;
}

.rrp-round__num {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #0f766e;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.rrp-round--locked .rrp-round__num {
  background: #cbd5e1;
  color: #475569;
}

.rrp-round__body {
  background: #f8fafc;
  border: 1px solid #e8eef4;
  border-radius: 12px;
  padding: 0.8rem 0.9rem 0.85rem;
}

.rrp-round--locked .rrp-round__body {
  background: #fff;
}

.rrp-round--must-release .rrp-round__body {
  border-color: #f59e0b;
  background: #fffbeb;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);
}

.rrp-round--must-release .rrp-round__num {
  background: #d97706;
}

.rrp-round__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.rrp-round__title {
  margin: 0;
  font-size: 0.92rem;
  font-weight: 700;
  color: #0f172a;
}

.rrp-round__window {
  margin: 0.15rem 0 0;
  font-size: 0.78rem;
  color: #64748b;
  font-weight: 500;
}

.rrp-round__pct {
  font-size: 1.15rem;
  font-weight: 800;
  color: #0f766e;
  letter-spacing: -0.03em;
  line-height: 1;
}

.rrp-round__pct small {
  font-size: 0.7rem;
  font-weight: 700;
  margin-left: 0.1rem;
  color: #64748b;
}

.rrp-round__left {
  display: block;
  margin: 0.2rem 0 0;
  font-size: 0.62rem;
  letter-spacing: 0;
}

.rrp-round__action {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.75rem;
  margin-top: 0.7rem;
  padding-top: 0.7rem;
  border-top: 1px dashed #e2e8f0;
}

.referral-plans-pct {
  font-weight: 600;
  color: #64748b;
  font-size: 0.8em;
  margin-left: 0.1rem;
}

.referral-plans-round-release-msg {
  margin: 0.75rem 1.15rem 0;
  padding: 0.65rem 0.85rem;
  border-radius: 8px;
  font-size: 0.84rem;
  line-height: 1.45;
}

.referral-plans-round-release-msg--success {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
}

.referral-plans-round-release-msg--error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.referral-plans-release-hint {
  margin: 0;
  font-size: 0.74rem;
  font-weight: 500;
  color: #64748b;
  line-height: 1.4;
  flex: 1 1;
  min-width: 160px;
}

.referral-plans-release-hint i {
  color: #0f766e;
  margin-right: 0.2rem;
}

.referral-plans-sequence-note {
  display: flex;
  gap: 0.7rem;
  align-items: flex-start;
  margin: 0 0 0.9rem;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  background: #f0fdfa;
  border: 1px solid #99f6e4;
  color: #134e4a;
}

.referral-plans-sequence-note > i {
  margin-top: 0.15rem;
  color: #0f766e;
}

.referral-plans-sequence-note strong,
.referral-plans-sequence-note p {
  margin: 0;
}

.referral-plans-sequence-note p {
  margin-top: 0.25rem;
  font-size: 0.82rem;
  line-height: 1.45;
}

.referral-plans-sequence-note__dest {
  color: #0f766e;
  font-weight: 600;
}

.referral-plans-skip-breakdown {
  margin: 0 0 0.85rem;
  padding: 0.65rem 0.9rem 0.65rem 1.4rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.78rem;
  color: #475569;
}

.referral-plans-btn-release {
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 0.42rem 0.85rem;
  border-radius: 8px;
  border: 1px solid #0f766e;
  background: linear-gradient(180deg, #14b8a6 0%, #0d9488 55%, #0f766e 100%);
  color: #fff;
  cursor: pointer;
  min-width: 5.75rem;
  box-shadow: 0 1px 2px rgba(15, 118, 110, 0.35);
  transition: filter 0.2s, box-shadow 0.2s;
}

.referral-plans-btn-release:hover:not(:disabled) {
  filter: brightness(1.06);
  box-shadow: 0 2px 6px rgba(15, 118, 110, 0.35);
}

.referral-plans-btn-release:disabled {
  cursor: not-allowed;
  box-shadow: none;
  background: #e2e8f0;
  border-color: #cbd5e1;
  color: #64748b;
}

.referral-plans-btn-release--loading:disabled {
  opacity: 0.95;
  background: linear-gradient(180deg, #14b8a6 0%, #0f766e 100%);
  border-color: #0f766e;
  color: #fff;
}

.referral-plans-btn-release--done:disabled {
  background: #e2e8f0;
  border-color: #cbd5e1;
  color: #64748b;
  font-weight: 600;
}

.referral-plans-modal__footer--left {
  justify-content: flex-end;
}

.referral-plans-view-footer {
  flex-wrap: wrap;
}

.referral-plans-view-footer__main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  width: 100%;
}

.referral-plans-modal--view .referral-plans-modal__footer {
  margin-top: 0;
  padding: 1rem 1.5rem 1.25rem;
  background: #fff;
  border-top: 1px solid #e2e8f0;
  box-shadow: 0 -4px 20px rgba(15, 23, 42, 0.04);
}

.referral-plans-modal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e2e8f0;
}

.referral-plans-modal__head h2,
.referral-plans-modal__head-text {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
}

.referral-plans-modal__close {
  background: #f1f5f9;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
}

.referral-plans-modal__close:hover:not(:disabled) {
  background: #e2e8f0;
}

.referral-plans-form {
  padding: 1rem 1.25rem 1.25rem;
  overflow-y: auto;
}

.referral-plans-form__row {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 0.9rem;
}

.referral-plans-form__row label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
}

.referral-plans-form__row input[type="text"] {
  width: 100%;
  padding: 0.65rem 0.8rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font: inherit;
  font-size: 0.92rem;
  color: #0f172a;
}

.referral-plans-form__row input[type="text"]:focus {
  outline: none;
  border-color: #0f766e;
}

.referral-plans-form__check {
  margin-bottom: 0.6rem;
}

.referral-plans-form__check label {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.88rem;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
}

.referral-plans-form__hint {
  font-size: 0.8rem;
  color: #64748b;
  margin: 0 0 0.75rem;
  line-height: 1.45;
}

.referral-plans-rounds-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
}

.referral-plans-rounds-table-wrap {
  overflow-x: auto;
  margin-bottom: 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.referral-plans-rounds-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}

.referral-plans-rounds-table th,
.referral-plans-rounds-table td {
  padding: 0.45rem 0.5rem;
  border-bottom: 1px solid #f1f5f9;
  text-align: left;
}

.referral-plans-rounds-table th {
  background: #f8fafc;
  font-weight: 600;
  color: #475569;
  font-size: 0.78rem;
}

.referral-plans-rounds-input {
  width: 100%;
  min-width: 0;
  max-width: 90px;
  padding: 0.4rem 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font: inherit;
  font-size: 0.86rem;
}

.referral-plans-rounds-input:focus {
  outline: none;
  border-color: #0f766e;
}

.referral-plans-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  margin-top: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px solid #f1f5f9;
}

.referral-plans-del-text {
  margin: 0 0 1rem;
  color: #64748b;
  font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/System/ReferralReleasePlansPage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;AACxB;;;AAGA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAElC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,0EAA0E;EAC1E,WAAW;EACX,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,0EAA0E;EAC1E,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,8CAA8C;EAC9C,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;;EAEE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".referral-release-plans-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.referral-plans-hero__icon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.4);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n}\n\n.referral-plans-toolbar {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 1rem;\n}\n\n.referral-plans-btn-primary,\n.referral-plans-btn-secondary,\n.referral-plans-btn-danger {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-family: inherit;\n  font-size: 0.9rem;\n  font-weight: 600;\n  padding: 0.55rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n\n.referral-plans-btn-primary {\n  background: #0f766e;\n  color: #fff;\n  border-color: #0d6560;\n}\n\n.referral-plans-btn-primary:hover:not(:disabled) {\n  background: #0d9488;\n}\n\n.referral-plans-btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.referral-plans-btn-view {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-family: inherit;\n  font-size: 0.86rem;\n  font-weight: 600;\n  padding: 0.45rem 0.9rem;\n  border-radius: 8px;\n  cursor: pointer;\n  border: 1px solid #0f766e;\n  background: #fff;\n  color: #0f766e;\n  white-space: nowrap;\n}\n\n.referral-plans-btn-view:hover:not(:disabled) {\n  background: #f0fdfa;\n}\n\n.referral-plans-btn-view:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.referral-plans-btn-secondary {\n  background: #fff;\n  color: #334155;\n  border-color: #e2e8f0;\n}\n\n.referral-plans-btn-secondary:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.referral-plans-btn-danger {\n  background: #b91c1c;\n  color: #fff;\n  border-color: #991b1b;\n}\n\n.referral-plans-btn-danger:hover:not(:disabled) {\n  background: #dc2626;\n}\n\n.referral-plans-card {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1.25rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.referral-plans-card__title {\n  margin: 0 0 1rem;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n}\n\n.referral-plans-loading {\n  color: #64748b;\n  padding: 0.5rem 0;\n}\n\n.referral-plans-empty {\n  color: #64748b;\n  margin: 0;\n}\n\n.referral-plans-msg {\n  margin: 0.75rem 0 0;\n  font-size: 0.9rem;\n}\n\n.referral-plans-msg--error {\n  color: #b91c1c;\n}\n\n.referral-plans-msg--success {\n  color: #0f766e;\n}\n\n.referral-plans-table-wrap {\n  overflow-x: auto;\n}\n\n.referral-plans-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.86rem;\n}\n\n.referral-plans-table th,\n.referral-plans-table td {\n  text-align: left;\n  padding: 0.65rem 0.75rem;\n  border-bottom: 1px solid #e2e8f0;\n  vertical-align: top;\n}\n\n.referral-plans-table th {\n  font-weight: 600;\n  color: #475569;\n  background: #f8fafc;\n}\n\n.referral-plans-table__name {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.referral-plans-table__created {\n  color: #334155;\n  font-size: 0.88rem;\n  white-space: nowrap;\n}\n\n.referral-plans-table__actions-col {\n  text-align: right;\n  width: 1%;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n\n.referral-plans-badge {\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.2rem 0.5rem;\n  border-radius: 6px;\n}\n\n.referral-plans-badge--on {\n  background: #d1fae5;\n  color: #047857;\n}\n\n.referral-plans-badge--off {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.referral-plans-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem 0.5rem;\n  align-items: center;\n}\n\n.referral-plans-linkbtn {\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #0f766e;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.referral-plans-linkbtn:hover:not(:disabled) {\n  color: #0d9488;\n}\n\n.referral-plans-linkbtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  text-decoration: none;\n}\n\n.referral-plans-linkbtn--danger {\n  color: #b91c1c;\n}\n\n.referral-plans-linkbtn--danger:hover:not(:disabled) {\n  color: #dc2626;\n}\n\n.referral-plans-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.referral-plans-modal-overlay--confirm {\n  z-index: 1200;\n  background: rgba(15, 23, 42, 0.6);\n}\n\n.referral-plans-confirm {\n  text-align: center;\n}\n\n.referral-plans-confirm__icon {\n  width: 48px;\n  height: 48px;\n  margin: 0 auto 0.85rem;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff7ed;\n  color: #c2410c;\n  font-size: 1.2rem;\n}\n\n.referral-plans-confirm__warn {\n  margin: 0 0 1.15rem;\n  font-size: 0.82rem;\n  line-height: 1.5;\n  color: #9a3412;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  border-radius: 10px;\n  padding: 0.7rem 0.8rem;\n  text-align: left;\n}\n\n.referral-plans-confirm .referral-plans-modal__footer {\n  justify-content: center;\n}\n\n.referral-plans-modal-overlay--view {\n  background: rgba(15, 23, 42, 0.55);\n  -webkit-backdrop-filter: blur(4px);\n  backdrop-filter: blur(4px);\n}\n\n.referral-plans-modal {\n  background: #fff;\n  border-radius: 12px;\n  max-width: 640px;\n  width: 100%;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);\n}\n\n.referral-plans-modal--sm {\n  max-width: 400px;\n  padding: 1.5rem;\n}\n\n.referral-plans-modal--view {\n  max-width: 640px;\n  border-radius: 18px;\n  box-shadow: 0 24px 50px rgba(15, 23, 42, 0.22);\n  border: 1px solid #e2e8f0;\n}\n\n.referral-plans-modal__head--view {\n  padding: 1.2rem 1.4rem 1.15rem;\n  border-bottom: none;\n  background: linear-gradient(135deg, #0f766e 0%, #0d9488 55%, #14b8a6 100%);\n  color: #fff;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.rrp-view-head {\n  min-width: 0;\n  flex: 1;\n}\n\n.rrp-view-head__row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.55rem 0.75rem;\n  margin-top: 0.25rem;\n}\n\n.referral-plans-modal__head--view h2 {\n  color: #fff;\n  font-size: 1.28rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  margin: 0;\n  line-height: 1.25;\n}\n\n.referral-plans-view-head-eyebrow {\n  margin: 0;\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.rrp-view-pill--on-dark.referral-plans-pill--active {\n  background: rgba(187, 247, 208, 0.22);\n  color: #ecfdf5;\n  border-color: rgba(167, 243, 208, 0.45);\n}\n\n.rrp-view-pill--on-dark.referral-plans-pill--inactive {\n  background: rgba(255, 255, 255, 0.12);\n  color: rgba(255, 255, 255, 0.9);\n  border-color: rgba(255, 255, 255, 0.22);\n}\n\n.referral-plans-modal__close--on-dark {\n  background: rgba(255, 255, 255, 0.12);\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  flex-shrink: 0;\n}\n\n.referral-plans-modal__close--on-dark:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.22);\n}\n\n.referral-plans-view-body {\n  padding: 0 1.25rem 0.5rem;\n  max-height: min(70vh, 600px);\n  overflow-y: auto;\n}\n\n.referral-plans-view-body--premium {\n  padding: 1.25rem 1.35rem 1rem;\n  max-height: min(72vh, 680px);\n  background: #f8fafc;\n}\n\n.referral-plans-view-loading {\n  text-align: center;\n  padding: 2.5rem 1rem;\n  color: #64748b;\n}\n\n.rrp-view-meta {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.7rem;\n  margin-bottom: 0.9rem;\n}\n\n@media (max-width: 560px) {\n  .rrp-view-meta {\n    grid-template-columns: 1fr;\n  }\n}\n\n.rrp-view-meta__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0.8rem 0.85rem;\n}\n\n.rrp-view-meta__item > i {\n  color: #0f766e;\n  font-size: 0.9rem;\n  margin-top: 0.15rem;\n}\n\n.rrp-view-meta__label {\n  display: block;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.rrp-view-meta__value {\n  display: block;\n  margin-top: 0.15rem;\n  font-size: 0.86rem;\n  font-weight: 600;\n  color: #0f172a;\n  line-height: 1.35;\n}\n\n.referral-plans-pill {\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 700;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  letter-spacing: 0.02em;\n}\n\n.referral-plans-pill--active {\n  background: #d1fae5;\n  color: #047857;\n  border: 1px solid #a7f3d0;\n}\n\n.referral-plans-pill--inactive {\n  background: #f1f5f9;\n  color: #64748b;\n  border: 1px solid #e2e8f0;\n}\n\n.referral-plans-view-rounds-block {\n  background: #fff;\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n  overflow: hidden;\n}\n\n.referral-plans-view-rounds-block__head {\n  padding: 0.95rem 1.15rem 0.8rem;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.referral-plans-view-rounds-block__head h3 {\n  margin: 0 0 0.2rem;\n  font-size: 0.98rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.referral-plans-view-rounds-block__head p {\n  margin: 0;\n  font-size: 0.8rem;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n.referral-plans-empty--in-card {\n  padding: 1.5rem 1.25rem;\n  margin: 0;\n  text-align: center;\n}\n\n.rrp-round-list {\n  list-style: none;\n  margin: 0;\n  padding: 0.65rem 0.85rem 0.85rem;\n}\n\n.rrp-round {\n  display: grid;\n  grid-template-columns: 36px minmax(0, 1fr);\n  gap: 0.85rem;\n  position: relative;\n  padding: 0.7rem 0 0.85rem;\n}\n\n.rrp-round:not(:last-child)::before {\n  content: \"\";\n  position: absolute;\n  left: 17px;\n  top: 42px;\n  bottom: 0;\n  width: 2px;\n  background: #e2e8f0;\n}\n\n.rrp-round__num {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #0f766e;\n  color: #fff;\n  font-size: 0.85rem;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n}\n\n.rrp-round--locked .rrp-round__num {\n  background: #cbd5e1;\n  color: #475569;\n}\n\n.rrp-round__body {\n  background: #f8fafc;\n  border: 1px solid #e8eef4;\n  border-radius: 12px;\n  padding: 0.8rem 0.9rem 0.85rem;\n}\n\n.rrp-round--locked .rrp-round__body {\n  background: #fff;\n}\n\n.rrp-round--must-release .rrp-round__body {\n  border-color: #f59e0b;\n  background: #fffbeb;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);\n}\n\n.rrp-round--must-release .rrp-round__num {\n  background: #d97706;\n}\n\n.rrp-round__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.rrp-round__title {\n  margin: 0;\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.rrp-round__window {\n  margin: 0.15rem 0 0;\n  font-size: 0.78rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.rrp-round__pct {\n  font-size: 1.15rem;\n  font-weight: 800;\n  color: #0f766e;\n  letter-spacing: -0.03em;\n  line-height: 1;\n}\n\n.rrp-round__pct small {\n  font-size: 0.7rem;\n  font-weight: 700;\n  margin-left: 0.1rem;\n  color: #64748b;\n}\n\n.rrp-round__left {\n  display: block;\n  margin: 0.2rem 0 0;\n  font-size: 0.62rem;\n  letter-spacing: 0;\n}\n\n.rrp-round__action {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem 0.75rem;\n  margin-top: 0.7rem;\n  padding-top: 0.7rem;\n  border-top: 1px dashed #e2e8f0;\n}\n\n.referral-plans-pct {\n  font-weight: 600;\n  color: #64748b;\n  font-size: 0.8em;\n  margin-left: 0.1rem;\n}\n\n.referral-plans-round-release-msg {\n  margin: 0.75rem 1.15rem 0;\n  padding: 0.65rem 0.85rem;\n  border-radius: 8px;\n  font-size: 0.84rem;\n  line-height: 1.45;\n}\n\n.referral-plans-round-release-msg--success {\n  background: #ecfdf5;\n  color: #047857;\n  border: 1px solid #a7f3d0;\n}\n\n.referral-plans-round-release-msg--error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.referral-plans-release-hint {\n  margin: 0;\n  font-size: 0.74rem;\n  font-weight: 500;\n  color: #64748b;\n  line-height: 1.4;\n  flex: 1;\n  min-width: 160px;\n}\n\n.referral-plans-release-hint i {\n  color: #0f766e;\n  margin-right: 0.2rem;\n}\n\n.referral-plans-sequence-note {\n  display: flex;\n  gap: 0.7rem;\n  align-items: flex-start;\n  margin: 0 0 0.9rem;\n  padding: 0.85rem 1rem;\n  border-radius: 12px;\n  background: #f0fdfa;\n  border: 1px solid #99f6e4;\n  color: #134e4a;\n}\n\n.referral-plans-sequence-note > i {\n  margin-top: 0.15rem;\n  color: #0f766e;\n}\n\n.referral-plans-sequence-note strong,\n.referral-plans-sequence-note p {\n  margin: 0;\n}\n\n.referral-plans-sequence-note p {\n  margin-top: 0.25rem;\n  font-size: 0.82rem;\n  line-height: 1.45;\n}\n\n.referral-plans-sequence-note__dest {\n  color: #0f766e;\n  font-weight: 600;\n}\n\n.referral-plans-skip-breakdown {\n  margin: 0 0 0.85rem;\n  padding: 0.65rem 0.9rem 0.65rem 1.4rem;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 0.78rem;\n  color: #475569;\n}\n\n.referral-plans-btn-release {\n  font-family: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  padding: 0.42rem 0.85rem;\n  border-radius: 8px;\n  border: 1px solid #0f766e;\n  background: linear-gradient(180deg, #14b8a6 0%, #0d9488 55%, #0f766e 100%);\n  color: #fff;\n  cursor: pointer;\n  min-width: 5.75rem;\n  box-shadow: 0 1px 2px rgba(15, 118, 110, 0.35);\n  transition: filter 0.2s, box-shadow 0.2s;\n}\n\n.referral-plans-btn-release:hover:not(:disabled) {\n  filter: brightness(1.06);\n  box-shadow: 0 2px 6px rgba(15, 118, 110, 0.35);\n}\n\n.referral-plans-btn-release:disabled {\n  cursor: not-allowed;\n  box-shadow: none;\n  background: #e2e8f0;\n  border-color: #cbd5e1;\n  color: #64748b;\n}\n\n.referral-plans-btn-release--loading:disabled {\n  opacity: 0.95;\n  background: linear-gradient(180deg, #14b8a6 0%, #0f766e 100%);\n  border-color: #0f766e;\n  color: #fff;\n}\n\n.referral-plans-btn-release--done:disabled {\n  background: #e2e8f0;\n  border-color: #cbd5e1;\n  color: #64748b;\n  font-weight: 600;\n}\n\n.referral-plans-modal__footer--left {\n  justify-content: flex-end;\n}\n\n.referral-plans-view-footer {\n  flex-wrap: wrap;\n}\n\n.referral-plans-view-footer__main {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.referral-plans-modal--view .referral-plans-modal__footer {\n  margin-top: 0;\n  padding: 1rem 1.5rem 1.25rem;\n  background: #fff;\n  border-top: 1px solid #e2e8f0;\n  box-shadow: 0 -4px 20px rgba(15, 23, 42, 0.04);\n}\n\n.referral-plans-modal__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.referral-plans-modal__head h2,\n.referral-plans-modal__head-text {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.referral-plans-modal__close {\n  background: #f1f5f9;\n  border: none;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.referral-plans-modal__close:hover:not(:disabled) {\n  background: #e2e8f0;\n}\n\n.referral-plans-form {\n  padding: 1rem 1.25rem 1.25rem;\n  overflow-y: auto;\n}\n\n.referral-plans-form__row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-bottom: 0.9rem;\n}\n\n.referral-plans-form__row label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n.referral-plans-form__row input[type=\"text\"] {\n  width: 100%;\n  padding: 0.65rem 0.8rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font: inherit;\n  font-size: 0.92rem;\n  color: #0f172a;\n}\n\n.referral-plans-form__row input[type=\"text\"]:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.referral-plans-form__check {\n  margin-bottom: 0.6rem;\n}\n\n.referral-plans-form__check label {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  font-size: 0.88rem;\n  font-weight: 500;\n  color: #334155;\n  cursor: pointer;\n}\n\n.referral-plans-form__hint {\n  font-size: 0.8rem;\n  color: #64748b;\n  margin: 0 0 0.75rem;\n  line-height: 1.45;\n}\n\n.referral-plans-rounds-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n.referral-plans-rounds-table-wrap {\n  overflow-x: auto;\n  margin-bottom: 0.5rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.referral-plans-rounds-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.82rem;\n}\n\n.referral-plans-rounds-table th,\n.referral-plans-rounds-table td {\n  padding: 0.45rem 0.5rem;\n  border-bottom: 1px solid #f1f5f9;\n  text-align: left;\n}\n\n.referral-plans-rounds-table th {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #475569;\n  font-size: 0.78rem;\n}\n\n.referral-plans-rounds-input {\n  width: 100%;\n  min-width: 0;\n  max-width: 90px;\n  padding: 0.4rem 0.5rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font: inherit;\n  font-size: 0.86rem;\n}\n\n.referral-plans-rounds-input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.referral-plans-modal__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.6rem;\n  margin-top: 0.5rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid #f1f5f9;\n}\n\n.referral-plans-del-text {\n  margin: 0 0 1rem;\n  color: #64748b;\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
